/* ----------------------------------------------------------------------------
   SUBSCRIPTION ENHANCER — PDP dynamic layer
   ----------------------------------------------------------------------------
   Companion to snippets/loop-widget-standard.liquid, which server-renders the
   static enhancements (Most Popular badge, tagline, "today" caption, truck
   select, savings-box skeleton). Loop's app script (assets/loop-widget.js)
   writes prices and the selling-plan description AFTER the theme renders, so
   everything price- or description-derived has to be computed here:

   - savings box headline/subtitle ("Save X% off today / and then Y% …")
   - "today" caption visibility (only while a first-order discount exists)
   - "Save up to N%" rewrite in Loop's description with the real recurring %
   - perks row decoration (icons on the description <li>s — Loop re-renders
     that <ul> on plan change, so it must be re-decorated client-side)

   Perks / active-subscriber state is computed in Liquid and exposed as
   data-se2-perks on the Loop container: those customers pay the same price
   on every order, so the "today" caption and renewal line are suppressed.

   The cart pricing box (.se-pricing-box-cart) is fully server-rendered in
   snippets/line-item.liquid and needs no JS — the drawer re-renders from
   Liquid on every cart change.
---------------------------------------------------------------------------- */
(function () {
  'use strict';

  /* Perk icons for the description list (brand green #003314). */
  var ICONS = {
    save: '<svg width="26" height="26" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m15.795 8.744-.008-.007L13.26 7.12a.42.42 0 0 1-.15-.558l.09-.144c.105-.193.378-.189.566-.075l1.607 1.036c-.02-.088-.035-.177-.058-.264a6.64 6.64 0 0 0-3.368-4.211 6.6 6.6 0 0 0-5.058-.43c-1.688.536-3.067 1.753-3.88 3.327a.546.546 0 1 1-.97-.502c.948-1.833 2.553-3.242 4.52-3.867a7.67 7.67 0 0 1 5.89.502 7.74 7.74 0 0 1 3.923 4.905l.016.073.725-1.43a.38.38 0 0 1 .533-.142l.144.055c.188.115.255.314.15.507L16.6 8.519l-.004.01-.096.175a.38.38 0 0 1-.237.187.38.38 0 0 1-.299-.043zM5.64 16.064c-1.938-1.002-3.368-2.734-3.922-4.847q-.057-.226-.1-.458l-.711 1.404c-.107.193-.346.309-.534.194L.228 12.3a.42.42 0 0 1-.15-.557l1.34-2.616.004-.01.096-.176a.38.38 0 0 1 .536-.143l.17.104.009.007 2.525 1.615a.42.42 0 0 1 .15.558l-.089.127c-.105.193-.378.206-.566.092l-1.615-1.04q.05.343.136.678c.476 1.815 1.703 3.294 3.368 4.156a6.6 6.6 0 0 0 5.058.43 6.6 6.6 0 0 0 3.881-3.273.546.546 0 1 1 .97.503 7.67 7.67 0 0 1-4.52 3.811 7.68 7.68 0 0 1-5.892-.502" fill="#003314"/></svg>',

    earn: '<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#se2-icon-earn-clip)"><path d="M14.42.07c1.145-.007 1.714-.01 2.12.014.403.023.645.072 1.139.173l.177.035c2.821.557 5.395 1.864 7.456 3.87h.002l.118.114c.457.44.888.883 1.275 1.376l.163.215q.116.154.233.305c.457.593.829 1.23 1.183 1.895l.078.146c.67 1.275 1.117 2.69 1.378 4.107l.028.143c.32 1.634.306 3.585-.028 5.215v.001l-.034.177a15 15 0 0 1-2.719 6.105l-.277.363-.012.015a13 13 0 0 1-2.55 2.452l-.206.152a14.5 14.5 0 0 1-3.932 2.064l-.144.048c-.569.188-1.145.336-1.732.462l-.164.035c-.942.19-1.869.234-2.832.23h-.181c-.857-.004-1.688-.021-2.52-.192h-.002l-.178-.035c-2.395-.48-4.547-1.496-6.465-2.996h-.001l-.096-.075h.001a13 13 0 0 1-2.525-2.603v-.001l-.153-.206a14.5 14.5 0 0 1-2.062-3.932l-.049-.144a16 16 0 0 1-.462-1.733l-.035-.164c-.191-.941-.233-1.868-.23-2.832v-.18l.007-.638c.015-.634.058-1.257.186-1.882v-.001l.034-.177c.445-2.25 1.36-4.356 2.763-6.175l.113-.149c.822-1.047 1.774-2.052 2.856-2.822h.001l.11-.08C8.477 1.236 11.346.087 14.252.073zm2.478 1.743c-4.182-.63-8.342.891-11.34 3.806-.359.355-.688.726-.995 1.128l-.012.015a11 11 0 0 0-.062.078c-.409.534-.77 1.084-1.102 1.667l-.06.103c-.97 1.669-1.588 3.746-1.606 5.684l-.001.15c-.01.983.002 1.94.17 2.907l.082.416.032.15c.607 2.734 2.152 5.345 4.306 7.163l.438.352.1.076a14.5 14.5 0 0 0 1.668 1.103v-.001l.101.06c2.869 1.667 6.475 2.042 9.662 1.237h.001c2.785-.748 5.392-2.349 7.16-4.658l.076-.1c.408-.533.77-1.084 1.1-1.668h.001l.06-.105c.663-1.154 1.092-2.422 1.37-3.715l.027-.125v-.001c.127-.628.186-1.244.207-1.87l.01-.63v-.163c-.01-3.589-1.494-6.882-4.005-9.416V5.46a11 11 0 0 0-.761-.685l-.27-.212-.099-.076v-.001a14 14 0 0 0-1.667-1.102l-.105-.06c-1.316-.754-2.773-1.22-4.259-1.473z" fill="#003314" stroke="#ecf4db" stroke-width=".167"/><path d="M15.421 4.812c.392.262.557.639.747 1.055l.261.557c.16.337.329.67.497 1.002l.104.206.83 1.646c.171.34.311.67.421 1.034l.096.012c1.04.125 2.076.269 3.112.418l1.221.175.253.036c1.278.179 1.278.179 1.533.476.146.222.183.334.19.597l.007.166c-.05.345-.309.586-.548.825l-.082.082-.172.17-.259.258c-.232.231-.466.46-.714.674-.24.208-.463.428-.686.653l-.501.505-.502.506-.115.115-.109.11-.103.105a2 2 0 0 1-.308.227c-.154.14-.154.14-.16.283.013.177.042.347.074.522l.038.238q.058.35.12.7l.082.469a537 537 0 0 0 .375 2.15l.055.309c.246 1.38.246 1.38.055 1.784-.224.242-.413.396-.747.429-.415-.022-.754-.235-1.11-.428a32 32 0 0 0-.55-.287 78 78 0 0 1-1.988-1.047l-.155-.085q-.307-.166-.61-.336l-.462-.253-.138-.078-.13-.07-.11-.061c-.31-.097-.598.107-.866.247l-.134.069-.43.223-.298.154a72 72 0 0 0-1.692.902q-.59.324-1.19.636l-.175.092-.162.084-.143.075c-.292.142-.566.154-.885.119a1.13 1.13 0 0 1-.586-.586c-.08-.598.087-1.225.192-1.81l.06-.338q.076-.443.155-.884l.338-1.91.053-.303.025-.137c.042-.24.077-.469.056-.712a3 3 0 0 0-.334-.326c-.534-.471-1.032-.977-1.533-1.483-.52-.528-.52-.528-1.07-1.025-.23-.2-.444-.418-.66-.634l-.143-.14-.136-.137-.123-.122c-.233-.266-.245-.495-.239-.838.032-.269.16-.423.353-.601.18-.112.339-.137.547-.173l.124-.021a60 60 0 0 1 1.538-.237l.317-.047 1.506-.22.653-.095.312-.046q.218-.03.434-.063l.13-.019c.165-.024.324-.043.492-.043l.05-.157a5 5 0 0 1 .202-.489l.086-.18.52-1.062.267-.547a243 243 0 0 1 .738-1.502q.151-.309.305-.616l.091-.19c.306-.609.72-1.012 1.443-.757Zm-.48 2.981-.054.11L14 9.673l-.305.609a24 24 0 0 0-.626 1.322c-.206.294-.446.376-.783.448q-.356.06-.714.108l-.264.038-.69.097-.704.1-.79.112q-.06.007-.122.017l-.324.045q-.24.036-.476.086c.3.363.626.694.96 1.026l.16.161c.264.264.531.518.814.76.231.205.448.424.666.642l.28.278.123.122c.292.333.245.69.22 1.113a15 15 0 0 1-.143.888l-.044.248-.116.644-.185 1.037-.065.36-.04.22-.034.194c-.03.164-.03.164.04.335 1.619-.824 1.619-.824 3.218-1.685l.128-.07q.14-.08.277-.168a1.5 1.5 0 0 1 1.085.002q.314.151.617.324l.225.12q.279.15.558.306l.47.258.486.267c.43.236.868.445 1.316.646a26 26 0 0 0-.244-1.605l-.035-.197-.147-.813q-.055-.3-.108-.601-.015-.09-.034-.182c-.186-1.065-.186-1.065.022-1.494l.136-.147.137-.152.15-.15.083-.083.172-.17.259-.257c.27-.27.545-.53.835-.78.236-.21.459-.436.682-.661l.255-.255.162-.162.147-.147c.113-.095.113-.095.106-.172l-1.621-.247c-.794-.122-.794-.122-1.59-.234l-.217-.03-.383-.05-.17-.024-.14-.018c-.312-.083-.558-.18-.746-.448l-.093-.212-.117-.253-.065-.143c-.143-.309-.299-.611-.452-.915l-.204-.408-.103-.207-.838-1.674z" fill="#003314" stroke="#ecf4db" stroke-width=".333"/></g><defs><clipPath id="se2-icon-earn-clip"><path fill="#fff" d="M0 0h30v30H0z"/></clipPath></defs></svg>',

    edit: '<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#se2-icon-edit-clip)"><path d="M9.094 1.691c.3.14.357.26.552.553V3.9h12.368V2.244c.285-.429.285-.429.552-.553.309-.041.57-.042.856.09.206.197.345.364.384.652l-.004.205v.11l-.008.345-.003.234-.01.573.115-.002q.546-.008 1.091-.012l.561-.007c1.323-.02 2.395.085 3.402 1.038.744.805 1.032 1.695 1.03 2.775v.248l.001.679.002.734.003 2.604.002 2.776v.9q0 1.45.004 2.897l.003 2.977q0 .836.002 1.67.002.712.001 1.423v.725q.003.333 0 .666 0 .12.002.239c.01 1.034-.336 1.959-1.053 2.716-.834.772-1.745 1.032-2.858 1.03l-.275.001h-.755l-.815.002-2.894.003-3.083.003h-.999q-1.61 0-3.219.003l-3.306.004-1.856.002h-1.58l-.805.002H5.497c-1.063.01-2-.308-2.787-1.052-.745-.805-1.032-1.695-1.03-2.775v-.249l-.001-.68-.001-.734a811 811 0 0 1-.002-2.607l-.002-3.317v-.36l-.002-2.9a1750 1750 0 0 1-.004-4.65 386 386 0 0 1 0-2.15 81 81 0 0 1-.001-.904c-.008-1.077.343-1.94 1.077-2.724.753-.725 1.664-1.023 2.692-1.01h.213l.554.005.567.003 1.11.008-.004-.147a58 58 0 0 1-.013-.777l-.005-.338-.003-.205c.038-.288.177-.455.384-.652.285-.132.546-.131.856-.09M3.959 6.274c-.793.92-.497 2.255-.497 3.368h24.736c.14-1.782.14-1.782-.522-3.398-.572-.535-1.208-.586-1.954-.582h-.17l-.89.002q-.441 0-.881.003l-.002.106-.012.48-.003.168c-.01.334-.037.537-.26.792-.288.224-.588.208-.938.166-.28-.133-.333-.223-.497-.497l-.055-1.215H9.646L9.59 6.882c-.262.394-.262.394-.496.497-.307.045-.579.04-.86-.094-.282-.267-.32-.482-.334-.86l-.004-.168-.006-.172-.011-.418a248 248 0 0 0-1.409-.008l-.675-.005c-.71 0-1.311.118-1.836.62m-.497 5.135-.007 7.416-.003 2.342v1.385l-.003 1.994v1.132l-.002.17c.003.715.116 1.32.622 1.85.618.532 1.34.505 2.116.504h1.738l1.503.001h1.222l3.467.002h3.408a4039 4039 0 0 0 6.349.003h1.705c.808.003 1.514-.039 2.124-.621.48-.556.505-1.184.503-1.89v-2.324l-.001-1.247-.002-3.29-.003-7.427z" fill="#003314"/><path d="m11.25 19.75 3.5 3.5 7-7.5" stroke="#003314" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="se2-icon-edit-clip"><path fill="#fff" d="M0 0h30v30H0z"/></clipPath></defs></svg>'
  };

  var SubscriptionEnhancer = {
    config: {
      sel: {
        container:       '[id^="loop-subscription-container-"]',
        group:           '.loop-subscription-group',
        radio:           '.loop-subscription-group-radio',
        priceContainer:  '.loop-subscription-group-price-container',
        priceAmount:     '.loop-subscription-group-price-amount',
        priceOriginal:   '.loop-subscription-group-price-amount-original',
        frequencySelect: '.loop-selling-plan-selector',
        onetimePrice:    '.loop-one-time-purchase-option-price-amount',
        description:     '.loop-selling-plan-selector-description',
        savingsBox:      '.se2-savings-box',
        todayLabel:      '.se2-price-today-label'
      },
      cls: {
        perks:    'se2-perks',
        perkIcon: 'se2-perk-icon',
        perkText: 'se2-perk-text'
      },
      // Rewrite "Save up to N%" in the perks row with the real recurring %.
      rewriteSaveUpTo: true,
      saveUpToRegex: /Save up to \d+(?:\.\d+)?%/i
    },

    state: {
      initialized: false,
      wiredGroups: new WeakSet(),
      wiredContainers: new WeakSet()
    },

    init: function () {
      if (this.state.initialized) return;
      this.state.initialized = true;

      var self = this;
      var containers = document.querySelectorAll(this.config.sel.container);
      containers.forEach(function (c) { self.enhanceContainer(c); });

      // Catch widgets rendered later (quick-buy, section re-renders).
      // childList only — our own text writes can't re-enter here.
      new MutationObserver(function () {
        document.querySelectorAll(self.config.sel.container).forEach(function (c) {
          if (!self.state.wiredContainers.has(c)) self.enhanceContainer(c);
        });
      }).observe(document.body, { childList: true, subtree: true });
    },

    /* ------------------------------ helpers ------------------------- */
    parsePrice: function (text) {
      if (text == null) return 0;
      var cleaned = String(text).replace(/[^\d.,-]/g, '').replace(/,/g, '');
      var n = parseFloat(cleaned);
      return Number.isFinite(n) ? n : 0;
    },

    formatPrice: function (n) {
      return '$' + (Math.round(n * 100) / 100).toFixed(2);
    },

    // Perks / active-subscriber flag, computed in Liquid
    // (snippets/loop-widget-standard.liquid) from customer tags.
    isPerksMember: function (container) {
      return container.getAttribute('data-se2-perks') === 'true';
    },

    // "Deliver every month" -> "month" / "Deliver every 2 months" -> "2 months"
    frequencyUnit: function (rawText) {
      if (!rawText) return 'month';
      var m = String(rawText).match(/every\s+(.+?)\s*$/i);
      return m ? m[1].trim() : 'month';
    },

    // "month" -> "on every future monthly order."
    // "2 months" -> "on every future order, delivered every 2 months."
    recurringPhrase: function (unit) {
      if (!unit || unit === 'month') return 'on every future monthly order.';
      return 'on every future order, delivered every ' + unit + '.';
    },

    // Idempotent writes — only touch the DOM when the value changes, so any
    // cross-firing MutationObserver can never re-trigger itself.
    setText: function (el, value) {
      if (!el) return;
      if (el.textContent !== value) el.textContent = value;
    },
    setHTML: function (el, value) {
      if (!el) return;
      if (el.innerHTML !== value) el.innerHTML = value;
    },
    setDisplay: function (el, value) {
      if (!el) return;
      if (el.style.display !== value) el.style.display = value;
    },

    /* ------------------------------ wiring -------------------------- */
    enhanceContainer: function (container) {
      this.state.wiredContainers.add(container);

      var self = this;
      var repaintAll = function () {
        container.querySelectorAll(self.config.sel.group).forEach(function (group) {
          self.updatePricing(container, group);
        });
      };
      var repaintAllLater = function () { setTimeout(repaintAll, 60); };

      // Purchase-option toggles and frequency changes — listened at container
      // level so the one-time radio (outside the group) also repaints.
      container.addEventListener('change', function (e) {
        if (!e.target) return;
        if (e.target.matches(self.config.sel.frequencySelect)
            || e.target.matches(self.config.sel.radio)
            || e.target.name === 'loop_purchase_option') {
          repaintAllLater();
        }
      });
      container.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest(self.config.sel.radio)) {
          repaintAllLater();
        }
      });

      container.querySelectorAll(this.config.sel.group).forEach(function (group) {
        self.updatePricing(container, group);
        self.attachListeners(container, group);
      });
    },

    /* Repaint everything that depends on prices / frequency. */
    updatePricing: function (container, group) {
      if (!group) return;

      var isPerks = this.isPerksMember(container);

      var todayEl    = group.querySelector(this.config.sel.priceAmount);
      var originalEl = group.querySelector(this.config.sel.priceOriginal);
      var onetimeEl  = container.querySelector(this.config.sel.onetimePrice);
      var freqSelect = group.querySelector(this.config.sel.frequencySelect);

      var todayPrice     = this.parsePrice(todayEl && todayEl.textContent);
      var recurringPrice = this.parsePrice(originalEl && originalEl.textContent);
      var onetimePrice   = this.parsePrice(onetimeEl && onetimeEl.textContent);

      var freqText = '';
      if (freqSelect && freqSelect.options && freqSelect.selectedIndex >= 0) {
        var opt = freqSelect.options[freqSelect.selectedIndex];
        if (opt) freqText = opt.textContent.trim();
      }
      var unit = this.frequencyUnit(freqText);

      // Discount base: the one-time price when available, otherwise the
      // recurring (strike) price.
      var base = onetimePrice > 0 ? onetimePrice
               : (recurringPrice > 0 ? recurringPrice : todayPrice);

      var hasFirstOrderDiscount = !isPerks
        && todayPrice > 0
        && recurringPrice > 0
        && todayPrice < recurringPrice - 0.001;

      var todayPct = (base > 0 && todayPrice > 0 && todayPrice < base)
        ? Math.round(((base - todayPrice) / base) * 100) : 0;
      var recurringPct = (base > 0 && recurringPrice > 0 && recurringPrice < base)
        ? Math.round(((base - recurringPrice) / base) * 100) : 0;

      // -- savings box --
      var box = group.querySelector(this.config.sel.savingsBox);
      if (box) {
        var headline = box.querySelector('.se2-sb-headline');
        var subtitle = box.querySelector('.se2-sb-subtitle');

        if (isPerks) {
          // Perks / active subscriber: same discount on the first order and
          // every recurring order — never show a renewal price line.
          var pct = todayPct > 0 ? todayPct : recurringPct;
          if (pct > 0) {
            this.setText(headline, 'Save ' + pct + '% on every order');
            this.setHTML(subtitle, 'Delivered every ' + unit + '.');
            this.setDisplay(subtitle, '');
          } else {
            var flatPerks = todayPrice || recurringPrice;
            this.setText(headline, this.formatPrice(flatPerks) + '/' + unit);
            this.setDisplay(subtitle, 'none');
          }
        } else if (hasFirstOrderDiscount && todayPct > 0) {
          this.setHTML(headline, 'Save ' + todayPct + '% off <span class="sub-block-perks">today</span>');
          if (recurringPct > 0) {
            this.setHTML(subtitle,
              'and then <span class="se2-sb-pct">' + recurringPct + '%</span> '
              + this.recurringPhrase(unit));
          } else {
            // First-order discount but no ongoing % vs one-time price.
            this.setHTML(subtitle,
              'Renews at <span class="se2-sb-pct">'
              + this.formatPrice(recurringPrice) + '/' + unit + '</span> after your first order.');
          }
          this.setDisplay(subtitle, '');
        } else if (recurringPct > 0) {
          this.setText(headline, 'Save ' + recurringPct + '% on every order');
          this.setHTML(subtitle, 'Delivered every ' + unit + '.');
          this.setDisplay(subtitle, '');
        } else {
          // No computable discount — show a neutral line instead of a wrong %.
          var flat = todayPrice || recurringPrice;
          this.setText(headline, this.formatPrice(flat) + '/' + unit);
          this.setDisplay(subtitle, 'none');
        }

        // Painted — reveal (rendered hidden in Liquid so an empty frame
        // never flashes if this script is unavailable).
        this.setDisplay(box, '');
      }

      // -- "today" caption: not rendered for Perks / active subscribers
      //    (Liquid), and only meaningful when a first-order discount exists --
      var todayLabel = group.querySelector(this.config.sel.todayLabel);
      this.setDisplay(todayLabel, hasFirstOrderDiscount ? '' : 'none');

      // -- "Save up to N%" rewrite in the perks copy --
      if (this.config.rewriteSaveUpTo) {
        var pctForCopy = recurringPct > 0 ? recurringPct
          : (isPerks && todayPct > 0 ? todayPct : 0);
        if (pctForCopy > 0) this.rewriteSaveUpTo(group, pctForCopy);
      }

      // -- perks row decoration (idempotent + self-healing) --
      this.decoratePerks(group);
    },

    /**
     * Rewrites "Save up to N%" inside the description with the actual
     * recurring discount. Once a <li> is decorated, its text lives in the
     * .se2-perk-text span — writing there preserves the icon.
     */
    rewriteSaveUpTo: function (group, pct) {
      var self = this;
      var rx = this.config.saveUpToRegex;
      var replacement = 'Save up to ' + pct + '%';
      group.querySelectorAll(this.config.sel.description).forEach(function (descEl) {
        descEl.querySelectorAll('li').forEach(function (li) {
          var target = li.querySelector('.' + self.config.cls.perkText) || li;
          var current = target.textContent;
          if (!rx.test(current)) return;
          self.setText(target, current.replace(rx, replacement));
        });
      });
    },

    classifyPerk: function (text) {
      var t = (text || '').toLowerCase();
      if (/\bearn\b/.test(t) || /puritypoints/.test(t)) return 'earn';
      if (/\bedit\b/.test(t) || /\bskip\b/.test(t) || /\bcancel\b/.test(t)) return 'edit';
      if (/\bsave\b/.test(t) || /\bpricing\b/.test(t) || /\bdiscount\b/.test(t)) return 'save';
      return 'save';
    },

    /**
     * Turn Loop's description <ul> into the 3-column perks row.
     * Each <li> becomes: icon on top, text below.
     * Idempotent and self-healing: if Loop re-renders the <ul> on a plan
     * change, the spans are gone and get rebuilt on the next call.
     */
    decoratePerks: function (group) {
      var self = this;
      group.querySelectorAll(this.config.sel.description).forEach(function (descEl) {
        descEl.querySelectorAll('ul').forEach(function (ul) {
          if (!ul.classList.contains(self.config.cls.perks)) {
            ul.classList.add(self.config.cls.perks);
          }
          ul.querySelectorAll(':scope > li').forEach(function (li) {
            var textSpan = li.querySelector(':scope > .' + self.config.cls.perkText);
            var iconSpan = li.querySelector(':scope > .' + self.config.cls.perkIcon);

            if (!textSpan) {
              textSpan = document.createElement('span');
              textSpan.className = self.config.cls.perkText;
              while (li.firstChild) textSpan.appendChild(li.firstChild);
              li.appendChild(textSpan);
            }

            // Trim the trailing period to match the design ("…anytime").
            var trimmed = textSpan.textContent.trim().replace(/\.$/, '');
            self.setText(textSpan, trimmed);

            var type = self.classifyPerk(textSpan.textContent);

            if (!iconSpan) {
              iconSpan = document.createElement('span');
              iconSpan.className = self.config.cls.perkIcon;
              li.insertBefore(iconSpan, textSpan);
            }
            if (iconSpan.getAttribute('data-icon-type') !== type) {
              iconSpan.setAttribute('data-icon-type', type);
              iconSpan.innerHTML = ICONS[type] || ICONS.save;
            }
          });
        });
      });
    },

    attachListeners: function (container, group) {
      if (this.state.wiredGroups.has(group)) return;
      this.state.wiredGroups.add(group);

      var self = this;
      var repaint = function () { self.updatePricing(container, group); };

      // Observe ONLY the Loop source price nodes. All of our writes go into
      // theme-rendered enhancer elements outside these nodes, so observer
      // loops are impossible.
      var watchPrice = function (node) {
        if (!node) return;
        new MutationObserver(repaint).observe(node, {
          childList: true,
          characterData: true,
          subtree: true
        });
      };
      watchPrice(group.querySelector(this.config.sel.priceAmount));
      watchPrice(group.querySelector(this.config.sel.priceOriginal));
      watchPrice(container.querySelector(this.config.sel.onetimePrice));
    }
  };

  window.SubscriptionEnhancer = SubscriptionEnhancer;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { SubscriptionEnhancer.init(); });
  } else {
    SubscriptionEnhancer.init();
  }
})();
